export enum Country {
    Albania,
    Andorra,
    Austria,
    Belarus,
    Belgium,
    BosniaAndHerzegovina,
    Bulgaria,
    Croatia,
    CzechRepublic,
    Denmark,
    Estonia,
    Finland,
    France,
    Germany,
    Greece,
    HolySee,
    Hungary,
    Iceland,
    Ireland,
    Italy,
    Latvia,
    Liechtenstein,
    Lithuania,
    Luxembourg,
    Malta,
    Moldova,
    Monaco,
    Montenegro,
    Netherlands,
    NorthMacedonia,
    Norway,
    Poland,
    Portugal,
    Romania,
    Russia,
    SanMarino,
    Serbia,
    Slovakia,
    Slovenia,
    Spain,
    Sweden,
    Switzerland,
    Ukraine,
    UnitedKingdom
}
